import { QueryClient } from '@tanstack/react-query'

// QueryClient único do app. Defaults conservadores; override por hook quando precisar.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
